import { Pipe, PipeTransform } from '@angular/core';
import { KpiType, StaffKpiData } from 'src/app/api/types/kpi';

@Pipe({
  name: 'kpiReportScoreRange'
})
export class KpiReportScoreRangePipe implements PipeTransform {

  transform(value: StaffKpiData['kpis'][number], score: number,): string {

    let result = ''

    if (value.data) {


      switch (score) {
        case 1: {
          result = this.getLowerBoundScore(value.data.two, value.data.thresholdOperator, this.getScoreSuffix(value.kpi))
          break;
        }
        case 2: {
          result = this.generateScoreRange(value.data.two, value.data.three, value.data.thresholdOperator, this.getScoreSuffix(value.kpi))
          break;
        }
        case 3: {
          result = this.generateScoreRange(value.data.three, value.data.four, value.data.thresholdOperator, this.getScoreSuffix(value.kpi))
          break;
        }
        case 4: {
          result = this.generateScoreRange(value.data.four, value.data.five, value.data.thresholdOperator, this.getScoreSuffix(value.kpi))
          break;
        }
        case 5: {
          result = this.getUpperBoundScore(value.data.five, value.data.thresholdOperator, this.getScoreSuffix(value.kpi))
          break;
        }
      }

    }

    return result

  }

  getLowerBoundScore(score: number, thresholdOperator: '<=' | '>=' | '<=truncated', scoreSuffix: string = "") {
    switch (thresholdOperator) {
      case '>=':
        return '< ' + score + scoreSuffix
      case '<=':
      case '<=truncated':
        return '> ' + score + scoreSuffix
    }
  }

  getUpperBoundScore(score: number, thresholdOperator: '<=' | '>=' | '<=truncated', scoreSuffix: string = "") {
    switch (thresholdOperator) {
      case '>=':
        return '>= ' + score + scoreSuffix
      case '<=':
      case '<=truncated':
        return `${score}${scoreSuffix} or less`
    }
  }

  generateScoreRange(lowerBound: number, upperBound: number, thresholdOperator: '<=' | '>=' | '<=truncated', scoreSuffix: string = "") {

    switch (thresholdOperator) {
      case '>=':
        if (lowerBound === upperBound - 1) {
          return `${lowerBound}${scoreSuffix}`
        }
        else {
          return `${lowerBound}${scoreSuffix} - ${upperBound - 1}${scoreSuffix}`
        }

      case '<=':
      case '<=truncated':
        return `${lowerBound}${scoreSuffix} or less`
    }


  }


  getScoreSuffix(kpi: KpiType) {
    let result = ''

    switch (kpi) {
      case 'tlExpenseReports':
        result = ' days'
        break;
      case 'consultingCapstone':
      case 'tlRenewalRate':
      case 'tlBudgets':
      case 'locationRenewalRate':
      case 'locationBudgets':
      case 'locationRetention':
      case 'locationPartnerCommunication':
      case 'locationDonorCare':
        result = '%'
    }

    return result
  }

}
